import React from 'react';
import { useCallbackObservable, useObservable } from 'react-use-observable';

import { Button } from 'antd';

import affiliateService from 'v2/services/affiliate';

import { Icon } from '@eduzz/ui-antd-theme';

export const Export = () => {
  const [loading] = useObservable(() => affiliateService.loadingExporting(), []);
  const [handleClickExport] = useCallbackObservable(() => affiliateService.export(), []);
  const [totalItems] = useObservable(() => affiliateService.getTotalItems(), []);

  return (
    <Button
      color='default'
      variant='filled'
      disabled={!totalItems || loading}
      onClick={handleClickExport}
      loading={loading}
      icon={<Icon.Download size={16} />}
    >
      {!loading ? 'Exportar' : 'Exportando...'}
    </Button>
  );
};
